module.exports = __webpack_public_path__ + "img/portraitGirl.87610792.svg";